import React from 'react';

import { ITEM_STATUSES } from 'modules/item/utils/itemStatus';
import { formatPrice } from 'modules/catalog/utils/formatPrice';
import { MarketplaceAPI } from 'revibe-api';

type Props = {
  item: MarketplaceAPI.Item;
  itemIsAvailable: boolean;
};

export const ItemSchemaOrg = ({ item, itemIsAvailable }: Props) => {
  if (item.status !== ITEM_STATUSES.APPROVED) {
    return null;
  }

  return (
    <div itemScope itemType="http://schema.org/Product">
      <meta itemProp="brand" content={item.seller.name} />
      <meta itemProp="name" content={item.name} />
      <meta itemProp="description" content={item.description || ''} />
      <meta itemProp="productID" content={item.id} />
      <meta itemProp="category" content={item.category.slug} />
      <meta
        itemProp="url"
        content={`https://www.revibe-upcycling.com/shop/item/${item.slug}`}
      />
      <meta itemProp="image" content={item.photos[0]?.link} />
      <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
        <link
          itemProp="availability"
          href={
            itemIsAvailable
              ? 'http://schema.org/InStock'
              : 'http://schema.org/OutOfStock'
          }
        />
        <link
          itemProp="itemCondition"
          href="http://schema.org/RefurbishedCondition"
        />
        <meta
          itemProp="price"
          content={formatPrice(item.selling_price || item.price)}
        />
        <meta itemProp="priceCurrency" content="EUR" />
      </div>
    </div>
  );
};
